import { cn } from "ui";

const PageBannerContainer = ({
  imageUrl,
  imageClassName,
  className,
  children,
}: {
  imageUrl: string;
  imageClassName?: string;
  className?: string;
  children: React.ReactNode;
}) => {
  return (
    <section
      className={cn(
        "grid grid-cols-1 gap-6 overflow-hidden rounded-lg border border-foundations-subtle pl-8 pt-8 lg:grid-cols-2",
        className
      )}
    >
      <div>{children}</div>

      <BannerImage imageUrl={imageUrl} className={imageClassName} />
    </section>
  );
};

const BannerImage = ({
  imageUrl,
  className,
}: {
  imageUrl: string;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "rounded-tl-2xl border-l border-t border-foundations-subtle bg-cover bg-center bg-no-repeat",
        className
      )}
      style={{
        backgroundImage: `url('${imageUrl}')`,
      }}
    ></div>
  );
};

const BannerTitle = ({ children }: { children: React.ReactNode }) => {
  return <div className="flex items-center">{children}</div>;
};

const BannerIcon = ({
  className,
  Icon,
}: {
  className: string;
  Icon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
}) => {
  return (
    <div className={cn("rounded p-1", className)}>
      <Icon className="h-4 w-4" />
    </div>
  );
};

const BannerTitleText = ({ children }: { children: React.ReactNode }) => {
  return (
    <span className="block p-2 text-sm font-medium text-foundations-bold">
      {children}
    </span>
  );
};

const BannerHeading = ({ children }: { children: React.ReactNode }) => {
  return (
    <h2 className="my-2 text-2xl font-medium text-foundations-boldest">
      {children}
    </h2>
  );
};

const BannerDescription = ({ children }: { children: React.ReactNode }) => {
  return <p className="my-4 text-sm text-foundations-bold">{children}</p>;
};

export const PageBanner = Object.assign(PageBannerContainer, {
  Title: BannerTitle,
  Icon: BannerIcon,
  TitleText: BannerTitleText,
  Heading: BannerHeading,
  Description: BannerDescription,
});
